import { Button, SpeechToTextButton } from '@progress/kendo-react-buttons';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { InputSuffix, Switch, TextArea, TextAreaChangeEvent, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { arrowUpIcon } from '@progress/kendo-svg-icons';
import React, { useState } from 'react';

interface PromptBoxProps {
    query: string;
    handleQueryChange: (event: TextAreaChangeEvent) => void;
    ddlValue: { value: any };
    handleDdlValueChange: (event: DropDownListChangeEvent) => void;
    docs: any[];
    ISEnabled: boolean;
    handleToggleISEnabled: (event: SwitchChangeEvent) => void;
    IEnabled: boolean;
    handleToggleIEnabled: (event: SwitchChangeEvent) => void;
    onSpeechToTextResult: (result: any) => void;
    handleSendButtonClick: () => void;
    isLoading?: boolean;
}

export const PromptBox: React.FC<PromptBoxProps> = ({ query, handleQueryChange, ddlValue, handleDdlValueChange, ISEnabled, handleToggleISEnabled, IEnabled, handleToggleIEnabled, onSpeechToTextResult, handleSendButtonClick, docs, isLoading = false }) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey && !isLoading) {
            event.preventDefault();
            handleSendButtonClick();
        }
    }

    return (
        <>
            <TextArea
                className={'k-align-items-center k-flex-col k-flex-md-row k-w-full rag-textarea'}
                flow='vertical'
                rows={1}
                onKeyDown={handleKeyDown}
                autoSize={true}
                resizable='none'
                placeholder="Ask anything ..."
                onChange={handleQueryChange}
                value={query}
                disabled={isLoading}

                suffix={() => (
                    <InputSuffix orientation="horizontal" className='k-w-full'>
                        <section className='k-d-flex k-align-items-center k-justify-content-between k-w-full textarea-suffix-section'>
                            <div className='textarea-inputs-section k-gap-md'>
                                {docs && docs.length > 0 && (
                                    <div className='k-align-items-center k-g-1 k-gap-sm k-d-flex'>
                                        <label className='details-label'>Details: </label>
                                        <DropDownList
                                            textField="name"
                                            size="small"
                                            rounded="full"
                                            value={ddlValue.value}
                                            onChange={handleDdlValueChange}
                                            dataItemKey="name"
                                            disabled={isLoading}
                                            style={{
                                                width: '150px'
                                            }} data={docs} />
                                    </div>
                                )}
                                <div className='k-align-items-center k-d-flex k-gap-sm'>
                                    <label className='internet-search-label'>Internal Data: </label>
                                    <Switch checked={IEnabled} onChange={handleToggleIEnabled} disabled={isLoading} />
                                </div>
                                <div className='k-align-items-center k-d-flex k-gap-sm'>
                                    <label className='internet-search-label'>Internet Search: </label>
                                    <Switch checked={ISEnabled} onChange={handleToggleISEnabled} disabled={isLoading} />
                                </div>

                            </div>
                            <div className='textarea-buttons-section'>
                                <SpeechToTextButton className="mx-1"
                                    fillMode="flat"
                                    themeColor="base"
                                    rounded="full"
                                    onResult={onSpeechToTextResult} />
                                <Button
                                    className='send-button'
                                    rounded='full'
                                    themeColor='base'
                                    onClick={handleSendButtonClick}
                                    disabled={query.trim() === '' || isLoading}
                                    svgIcon={arrowUpIcon} />
                            </div>
                        </section>
                    </InputSuffix>
                )}
            />
        </>
    );
};
